$.view.addHelper({
	/**
	 * Check if value exists
	 *
	 * @returns {Boolean}
	 */
	contains(...args) {
		const value = this.val || [];

		return args.some(arg => value[arg] || null);
	},

	/**
	 * Check for property value
	 *
	 * @param {String} prop
	 * @param {*} value
	 * @returns {Number}
	 */
	where(prop, value) {
		return this.val && this.val.filter(el => el[prop] === value);
	},

	/**
	 * Return the number of items in the current collection or makes comparison
	 *
	 * @param {Number} [value]
	 * @returns {*}
	 */
	length(value) {
		const length = $.toArray(this.val).length;

		if (value) {
			return length === value;
		}

		return length;
	},

	/**
	 * Determine if the current value exists in a provided array
	 *
	 * @param {Array} array
	 * @param {String} [key]
	 * @returns {Boolean}
	 */
	in(array, key) {
		return $.toArray(array)
			.includes(key ? this.data[key] : this.val);
	},

	/**
	 * Retrieve value at specific array index
	 *
	 * @param {Number|String} index
	 * @param {*} [fallback]
	 * @returns {*}
	 */
	index(index, fallback) {
		return this.val[index] || fallback;
	},

	/**
	 * Join values
	 *
	 * @param {String} [separator=', ']
	 * @returns {String}
	 */
	join(separator = ', ') {
		return Array.isArray(this.val) ?
			this.val.join(separator) : this.val;
	}
});